export enum BgPathsForLdAccounts {
  WAITING = 'assets/images/icons/bg-waiting-ld-account.svg',
  ERROR = 'assets/images/icons/bg-error-ld-account.svg',
  SUCCESS = 'assets/images/icons/bg-success-ld-account.svg',
}
